<div class="dialog-header">
  <h2 mat-dialog-title>{{ data.title }}</h2>
</div>
<mat-dialog-content class="mat-dialog-content centered">
  <div class="confirm-text">{{ data.message }}</div>
</mat-dialog-content>
<div mat-dialog-actions class="action-btns">
  <button class="btn" (click)="cancel()">{{ data.cancelLabel || 'Cancel' }}</button>
  <button class="btn primary" (click)="confirm()">{{ data.confirmLabel || 'Confirm' }}</button>
</div>
